import { render, staticRenderFns } from "./MixedColorLabel.vue?vue&type=template&id=031b3864&scoped=true&"
import script from "./MixedColorLabel.vue?vue&type=script&lang=js&"
export * from "./MixedColorLabel.vue?vue&type=script&lang=js&"
import style0 from "./MixedColorLabel.vue?vue&type=style&index=0&id=031b3864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b3864",
  null
  
)

export default component.exports